<template>
  <div>
    <v-dialog v-model="isOpen" width="720px">
      <v-card class="teacher-goodbye-dialog pb-8">
        <v-card-title primary-title>
          <v-spacer></v-spacer>
          <v-btn outlined small fab @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- START: Grade layout -->
        <div class="teacher-goodbye-dialog__inner teacher-goodbye-dialog__inner--grade pt-2">
          <!-- eslint-disable-next-line max-len -->
          <h2 v-if="!grade" class="mb-4 text-center">{{ title }}</h2>

          <v-row class="responsive-row">
            <v-col :sm="4" :xs="12" class="px-8 pe-sm-2" v-if="!grade || grade === 1">
              <button-circular
                :src="emojis.excited"
                class="me-4 teacher-goodbye-dialog__grade"
                :label="!grade ? $t('amazing') : null"
                :disabled="!!grade"
                @click="submitGrade(1)"
                :loading="loading === 1"
              ></button-circular>
            </v-col>
            <v-col :sm="4" :xs="12" class="px-8 ps-sm-2" v-if="!grade || grade === 2">
              <button-circular
                class="me-4 teacher-goodbye-dialog__grade"
                :label="!grade ? $t('fineBut') : null"
                :src="emojis.smiling"
                :disabled="!!grade"
                :loading="loading === 2"
                @click="submitGrade(2)"
              ></button-circular>
            </v-col>
            <v-col :sm="4" :xs="12" class="px-8 ps-sm-2" v-if="!grade || grade === 3">
              <button-circular
                class="me-4 teacher-goodbye-dialog__grade"
                :label="!grade ? $t('somethingWentWrong') : null"
                :src="emojis.suspicious"
                :disabled="!!grade"
                :loading="loading === 3"
                @click="submitGrade(3)"
              ></button-circular>
            </v-col>
          </v-row>
        </div>
        <!-- END: Grade layout -->
        <!-- START: Message layout -->
        <div
          v-if="grade > 1"
          class="teacher-goodbye-dialog__inner teacher-goodbye-dialog__inner--massage pt-2"
        >
          <h2 class="mb-2 px-4 text-center">{{ title }}</h2>
          <v-textarea
            v-model="message"
            ref="RatingMessageInput"
            :label="$t('yourMessage')"
            class="teacher-goodbye-dialog__message-area"
            rows="3"
            outlined
            block
            @keyup.enter="submitMessage"
          ></v-textarea>

          <v-btn
            :disabled="!message"
            :loading="messageLoading"
            color="primary"
            class="teacher-goodbye-dialog__message-button"
            large
            depressed
            rounded
            block
            @click="submitMessage"
          >{{ $t('send') }}</v-btn>
        </div>
        <!-- END: Message layout -->
        <!-- START: Share layout -->
        <div
          v-if="grade === 1"
          class="teacher-goodbye-dialog__inner teacher-goodbye-dialog__inner--share"
        >
          <h2 class="mb-2 text-center">{{ title }}</h2>
          <p class="text-center lighten">{{ $t('helpToShare')}}</p>
          <v-row class="teacher-goodbye-dialog__row responsive-row">
            <v-col :sm="6" :xs="12" class="px-8 pe-sm-2">
              <v-btn
                color="primary"
                rounded
                block
                depressed
                large
                @click="submitShared('facebook')"
              >
                <v-icon class="me-4">mdi-facebook</v-icon>{{ $t('shareViaFacebook') }}
              </v-btn>
            </v-col>
            <v-col :sm="6" :xs="12" class="px-8 ps-sm-2">
              <v-btn
                color="secondary"
                class="color-primary"
                rounded
                block
                depressed
                large
                @click="submitShared('email')"
              >
                <v-icon class="me-4">mdi-email</v-icon>{{ $t('shareViaEmail') }}
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <!-- END: Grade layout -->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { emojis } from '@/main.js';
import shareFacebook from 'share-facebook';
import buttonCircular from '@/components/ButtonCircular.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    buttonCircular,
  },
  props: ['testOnly'],
  watch: {
    isOpen(val) {
      if (!val) this.goHome();
    },
  },
  data: () => ({
    isOpen: false,
    loading: 0,
    grade: 0,
    messageLoading: false,
    message: '',
    shared: '',
  }),
  computed: {
    ...mapGetters(['auth']),
    lessonId() {
      return this.$route.params.lesson;
    },
    emojis() {
      return emojis;
    },
    title() {
      if (this.grade === 1) return this.$t('inYourHands');
      if (this.grade > 1) return this.$t('whatCanWeImprove');
      return this.$t(`howDoYouRate${this.testOnly ? 'Test' : ''}`);
    },
    web() {
      return `https://www.ucime.se/${this.$i18n.locale === 'sk' ? 'sk' : ''}`;
    },
  },
  methods: {
    facebookShare() {
      const url = shareFacebook({
        href: this.web,
        app_id: '273849540304188',
      });
      this.openWindow(url);
    },
    emailShare() {
      const subject = this.$t('toolForLearning');
      const body = this.$t('justFinishedLesson');
      const url = `mailto:${this.auth.email}?subject=${subject}&body=${body}%0D%0A%0D%0A${this.web}`;
      this.openWindow(url);
    },
    openWindow(url) {
      const win = window.open(url, '_blank');
      win.focus();
    },
    goHome() {
      this.$router.push('/home');
    },
    open() {
      this.isOpen = true;
    },

    close() {
      this.isOpen = false;
    },

    submitForm() {},
    submitGrade(grade) {
      this.loading = grade;
      this.$store
        .dispatch('rateLesson', {
          email: this.auth.email,
          lesson: this.lessonId,
          data: {
            type: 'grade',
            value: grade,
          },
        })
        .then(() => {
          this.grade = grade;
          this.loading = 0;
        });
    },
    submitMessage() {
      this.messageLoading = true;
      this.$store
        .dispatch('rateLesson', {
          email: this.auth.email,
          lesson: this.lessonId,
          data: {
            type: 'message',
            value: this.message,
          },
        })
        .then(() => {
          this.messageLoading = false;
          this.goHome();
        });
    },
    submitShared(type) {
      this[`${type}Share`]();
      this.$store
        .dispatch('rateLesson', {
          email: this.auth.email,
          lesson: this.lessonId,
          data: {
            type: 'shared',
            value: type,
          },
        })
        .then(() => {
          this.goHome();
        });
    },
  },
};
</script>

<style lang="scss">
.teacher-goodbye-dialog {
  &__avatar {
    margin: 0 auto;
    font-size: 62px;
  }
  &__message-button {
    width: 50% !important;
    min-width: 50% !important;
    margin: 0 auto;
    background-color: #eaeaf0 !important;
  }
  &__message-area {
    width: 75% !important;
    min-width: 75% !important;
    margin: 20px auto 0 auto !important;
  }
  &__grade {
    .button-circular {
      width: 120px !important;
      height: 120px !important;
      background: white;

      img {
        width: 55px !important;
        height: 55px !important;
      }
    }
  }
  &__inner {
    max-width: 600px;
    margin: 0 auto;
  }
}
</style>
